// ============================================================
// ARBORESCENCE DES MÉDIAS — Curieux Hub
// ------------------------------------------------------------
// Vue hiérarchique reflétant l'architecture réelle du site.
// Chaque nœud possède :
//  - id       : identifiant unique
//  - label    : titre affiché
//  - kind     : "section" | "group" | "media"
//  - children : sous-nœuds (optionnel)
//  - media    : entrées de média finales (feuilles)
//
// Un média (feuille) contient :
//  - filename : nom exact du fichier
//  - url      : chemin (local /media/... ou URL CDN externe)
//  - type     : "image" | "video" | "audio"
//  - alt      : description courte
//  - cdn      : true si hébergé sur CDN externe (non remplaçable directement)
// ============================================================

const IMG = "/media/images";
const VID = "/media/videos";
const CDN_ART = "https://customer-assets.emergentagent.com/job_romance-decors/artifacts";
const CDN_HOST = "https://romance-decors.emergent.host";
const CDN_LEG = "https://customer-assets.emergentagent.com/job_83d2dd7c-b8fa-4317-9dcd-1ec71bead410/artifacts";

const M = (o) => o; // helper de lisibilité

export const MEDIA_TREE = [
  // ============================================================
  // ACCUEIL
  // ============================================================
  {
    id: "accueil",
    label: "Accueil",
    children: [
      {
        id: "accueil-window-refuge",
        label: "Fenêtre — Le refuge",
        media: [M({ filename: "bassin-mineral.png", url: `${IMG}/refuge/bassin-mineral.png`, type: "image", alt: "Bassin minéral (image de fond)" })],
      },
      {
        id: "accueil-window-experiences",
        label: "Fenêtre — Expériences",
        media: [M({ filename: "bain-de-fleurs.png", url: `${IMG}/experiences/bain-de-fleurs.png`, type: "image", alt: "Bain de fleurs (image de fond)" })],
      },
      {
        id: "accueil-window-avis",
        label: "Fenêtre — Avis",
        media: [M({ filename: "chambre-cocon.png", url: `${IMG}/refuge/chambre-cocon.png`, type: "image", alt: "Chambre cocon (image de fond)" })],
      },
      {
        id: "accueil-window-tarifs",
        label: "Fenêtre — Tarifs",
        media: [M({ filename: "cuisine-ete.jpeg", url: `${IMG}/refuge/cuisine-ete.jpeg`, type: "image", alt: "Cuisine d'été (image de fond)" })],
      },
      {
        id: "accueil-window-bon-cadeau",
        label: "Fenêtre — Bon cadeau",
        media: [M({ filename: "decor-chandelier.jpeg", url: `${IMG}/experiences/decor-chandelier.jpeg`, type: "image", alt: "Chandelier (image de fond)" })],
      },
      {
        id: "accueil-window-reserver",
        label: "Fenêtre — Réserver",
        media: [M({ filename: "jardin-tropical.jpeg", url: `${IMG}/refuge/jardin-tropical.jpeg`, type: "image", alt: "Jardin tropical (image de fond)" })],
      },
    ],
  },

  // ============================================================
  // LE REFUGE
  // ============================================================
  {
    id: "refuge",
    label: "Le Refuge",
    children: [
      {
        id: "refuge-hero",
        label: "Vidéo Hero",
        media: [
          M({ filename: "refuge-hero.mp4", url: `${VID}/refuge-hero.mp4`, type: "video", alt: "Vidéo Hero (format MP4)" }),
          M({ filename: "refuge-hero.webm", url: `${VID}/refuge-hero.webm`, type: "video", alt: "Vidéo Hero (format WebM)" }),
          M({ filename: "hero-poster.png", url: `${IMG}/refuge/hero-poster.png`, type: "image", alt: "Image de repli de la vidéo Hero" }),
        ],
      },
      {
        id: "refuge-bassin",
        label: "Le bassin",
        media: [
          M({ filename: "bassin-mineral.png", url: `${IMG}/refuge/bassin-mineral.png`, type: "image", alt: "Bassin minéral extérieur" }),
          M({ filename: "bassin-vue-chambre.jpeg", url: `${IMG}/refuge/bassin-vue-chambre.jpeg`, type: "image", alt: "Bassin — vue depuis la chambre" }),
          M({ filename: "bassin-vue-ensemble.jpeg", url: `${IMG}/refuge/bassin-vue-ensemble.jpeg`, type: "image", alt: "Bassin — vue d'ensemble" }),
        ],
      },
      {
        id: "refuge-cuisine",
        label: "La cuisine",
        media: [
          M({ filename: "cuisine-ete.jpeg", url: `${IMG}/refuge/cuisine-ete.jpeg`, type: "image", alt: "Cuisine d'été atypique" }),
        ],
      },
      {
        id: "refuge-chambre",
        label: "La chambre",
        media: [
          M({ filename: "chambre-cocon.png", url: `${IMG}/refuge/chambre-cocon.png`, type: "image", alt: "Chambre cocon avec bougies" }),
          M({ filename: "chambre-3-voyageurs.png", url: `${IMG}/refuge/chambre-3-voyageurs.png`, type: "image", alt: "Configuration 3 voyageurs" }),
          M({ filename: "chambre-berceau.png", url: `${IMG}/refuge/chambre-berceau.png`, type: "image", alt: "Configuration avec berceau" }),
        ],
      },
      {
        id: "refuge-jardin",
        label: "Le jardin",
        media: [
          M({ filename: "jardin-tropical.jpeg", url: `${IMG}/refuge/jardin-tropical.jpeg`, type: "image", alt: "Jardin tropical du refuge" }),
          M({ filename: "jardin-entree.jpeg", url: `${IMG}/refuge/jardin-entree.jpeg`, type: "image", alt: "Entrée du jardin" }),
        ],
      },
    ],
  },

  // ============================================================
  // EXPÉRIENCES
  // ============================================================
  {
    id: "experiences",
    label: "Expériences",
    children: [
      // -------- BAIN DE FLEURS --------
      {
        id: "exp-bain",
        label: "Bain de fleurs",
        children: [
          {
            id: "exp-bain-cover",
            label: "Photo de couverture",
            media: [
              M({ filename: "bain-de-fleurs.png", url: `${IMG}/experiences/bain-de-fleurs.png`, type: "image", alt: "Photo de couverture Bain de fleurs" }),
            ],
          },
          {
            id: "exp-bain-immersive",
            label: "Page immersive",
            children: [
              {
                id: "exp-bain-hero",
                label: "Hero vidéo",
                media: [
                  M({ filename: "bdf-hero.mov", url: `${CDN_ART}/gow13xs7_copy_6F7A6086-FFCF-490C-BF3D-4192A1E66AA2.mov`, type: "video", alt: "Vidéo Hero du bain de fleurs", cdn: true }),
                  M({ filename: "bdf-frame.jpg", url: `${CDN_HOST}/bdf_frame.jpg`, type: "image", alt: "Poster de la vidéo Hero", cdn: true }),
                  M({ filename: "bdf-audio.mp3", url: `${CDN_HOST}/bdf_audio.mp3`, type: "audio", alt: "Ambiance sonore", cdn: true }),
                ],
              },
              {
                id: "exp-bain-gallery",
                label: "Galerie photos",
                media: [
                  M({ filename: "bain-de-fleurs.png", url: `${IMG}/experiences/bain-de-fleurs.png`, type: "image", alt: "Bain de fleurs (galerie)" }),
                ],
              },
            ],
          },
        ],
      },

      // -------- PETIT DÉJEUNER --------
      {
        id: "exp-pdj",
        label: "Petit déjeuner",
        children: [
          {
            id: "exp-pdj-cover",
            label: "Photo de couverture",
            media: [
              M({ filename: "petit-dejeuner-1.png", url: `${IMG}/experiences/petit-dejeuner-1.png`, type: "image", alt: "Photo de couverture Petit déjeuner" }),
            ],
          },
          {
            id: "exp-pdj-immersive",
            label: "Page immersive",
            children: [
              {
                id: "exp-pdj-hero",
                label: "Hero vidéo",
                media: [
                  M({ filename: "pdj-hero.mov", url: `${CDN_ART}/21via0mf_18d0047b88a64789a30f1be7ea8903ae.mov`, type: "video", alt: "Vidéo Hero du petit déjeuner", cdn: true }),
                  M({ filename: "pdj-frame.png", url: `${CDN_ART}/z0skj8rw_8AEE47E2-E275-4C36-B5F9-936FAC7D09F6.png`, type: "image", alt: "Poster de la vidéo Hero", cdn: true }),
                  M({ filename: "pdj-audio.mp3", url: `${CDN_HOST}/pdj_audio.mp3`, type: "audio", alt: "Ambiance sonore", cdn: true }),
                ],
              },
              {
                id: "exp-pdj-gallery",
                label: "Galerie photos",
                media: [
                  M({ filename: "pdj-01.png", url: `${CDN_ART}/rhmlrsyk_0807FACE-597C-4463-B239-691848563112.png`, type: "image", alt: "Table dressée avec fruits, pain, confitures", cdn: true }),
                  M({ filename: "pdj-02.png", url: `${CDN_ART}/8u4i6ze5_8CA11EC5-32E3-4661-939B-76EE63CF05E1.png`, type: "image", alt: "Petit déjeuner avec fruits frais et café", cdn: true }),
                  M({ filename: "pdj-03.png", url: `${CDN_ART}/1v5ug7v4_1E9CB955-D044-4A1A-A6DA-66B438AD9247.png`, type: "image", alt: "Table dressée sous la pergola", cdn: true }),
                ],
              },
            ],
          },
        ],
      },

      // -------- DÉCORS DU REFUGE --------
      {
        id: "exp-decors",
        label: "Décors du Refuge",
        children: [
          {
            id: "exp-decors-cover",
            label: "Photo de couverture",
            media: [
              M({ filename: "decor-nuit-rouge.png", url: `${IMG}/experiences/decor-nuit-rouge.png`, type: "image", alt: "Photo de couverture Décors — Nuit Rouge" }),
            ],
          },
          {
            id: "exp-decors-immersive",
            label: "Page immersive",
            children: [
              {
                id: "exp-decors-hero",
                label: "Hero vidéo",
                media: [
                  M({ filename: "decors-hero.mov", url: `${CDN_ART}/p9dvc3db_RPReplay_Final1776339998.mov`, type: "video", alt: "Vidéo Hero des décors", cdn: true }),
                  M({ filename: "decors-frame.jpg", url: `${CDN_HOST}/decors_frame.jpg`, type: "image", alt: "Poster de la vidéo Hero", cdn: true }),
                  M({ filename: "decors-audio.mp3", url: `${CDN_HOST}/hero_audio.mp3`, type: "audio", alt: "Ambiance sonore", cdn: true }),
                ],
              },
              {
                id: "exp-decors-gallery",
                label: "Galerie photos — Nuit Rouge",
                media: [
                  M({ filename: "nuit-rouge-01.png", url: `${CDN_LEG}/r8gltfqq_2A707590-0455-4E7E-8FA3-3272B78CAC60.png`, type: "image", alt: "Lit décoré Nuit Rouge", cdn: true }),
                  M({ filename: "nuit-rouge-02.jpeg", url: `${CDN_LEG}/s1bbtmzq_IMG_0829.jpeg`, type: "image", alt: "Chandelier romantique avec roses", cdn: true }),
                  M({ filename: "nuit-rouge-03.png", url: `${CDN_ART}/fdxicf9n_6843AA91-2ECE-40D1-9E52-1A025694AE50.png`, type: "image", alt: "Terrasse décorée avec bassin", cdn: true }),
                ],
              },
            ],
          },
        ],
      },
    ],
  },

  // ============================================================
  // TARIFS
  // ============================================================
  {
    id: "tarifs",
    label: "Tarifs",
    media: [],
    note: "Cette page ne contient que du texte et des tarifs (modifiables via l'onglet Tarifs).",
  },

  // ============================================================
  // RÉSERVER
  // ============================================================
  {
    id: "reserver",
    label: "Réserver",
    media: [],
    note: "Cette page intègre le calendrier Lodgify. Aucune image locale n'est utilisée.",
  },

  // ============================================================
  // AVIS
  // ============================================================
  {
    id: "avis",
    label: "Avis",
    media: [],
    note: "Cette page affiche les témoignages voyageurs (modifiables via l'onglet Avis).",
  },

  // ============================================================
  // BON CADEAU
  // ============================================================
  {
    id: "bon-cadeau",
    label: "Bon cadeau",
    media: [],
    note: "Cette page ne contient que du texte et un composeur (modifiable via Tarifs pour les prix).",
  },
];

// Helper — flatten all leaves for search or comparison
export function flattenTree(tree = MEDIA_TREE) {
  const out = [];
  const walk = (node, path) => {
    const p = [...path, node.label];
    if (node.media && node.media.length > 0) {
      node.media.forEach((m) => out.push({ ...m, path: p }));
    }
    (node.children || []).forEach((c) => walk(c, p));
  };
  tree.forEach((n) => walk(n, []));
  return out;
}

export default MEDIA_TREE;
